import { IEmailChangeViewModel } from '../types/emailChangeViewModel'

export class EmailChangeViewModel implements IEmailChangeViewModel
{
    emailAddress: string = ''
    leaseNumber: string = ''
    isActiveLease: boolean = false
    hasExistingEmailChangeRequest: boolean = false
    existingEmailChangeRequestId: string = ''
    referenceNumber: string = ''
}